/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumption_Dju_CorrectionInputs */



/**
* | output |
* | --- |
* | "Weather correction (degree days)" |
*
* @param {Consumption_Dju_CorrectionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_dju_correction = /** @type {((inputs?: Consumption_Dju_CorrectionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Dju_CorrectionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Weather correction (degree days)")
	return /** @type {LocalizedString} */ ("Correction climatique (DJU)")
});